import script from "./SubscribeDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribeDesktop.vue?vue&type=script&setup=true&lang=js"

import "./SubscribeDesktop.vue?vue&type=style&index=0&id=91273c44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91273c44"]])

export default __exports__